// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TrackedJobsPollQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackedJobFilter>;
}>;


export type TrackedJobsPollQuery = { __typename?: 'Query', trackedJobs: Array<{ __typename?: 'TrackedJob', id: string, pollIntervalInMs: number, progressCurrent?: number | null | undefined, progressTotal?: number | null | undefined, progressMessage?: string | null | undefined, status: { __typename?: 'TrackedJobStatusDetail', code: Types.TrackedJobStatus }, result?:
      | { __typename?: 'Asset', id: string, attachmentUrl: string, fileName?: string | null | undefined }
      | { __typename?: 'BillOcr', id: string }
     | null | undefined, parent?: { __typename?: 'ProductOffering', id: string } | null | undefined }> };


export const TrackedJobsPollDocument = gql`
    query TrackedJobsPoll($filter: TrackedJobFilter) {
  trackedJobs(filter: $filter) {
    id
    pollIntervalInMs
    progressCurrent
    progressTotal
    progressMessage
    status {
      code
    }
    result {
      ... on Asset {
        id
        attachmentUrl
        fileName
      }
      ... on BillOcr {
        id
      }
    }
    parent {
      ... on ProductOffering {
        id
      }
    }
  }
}
    `;

/**
 * __useTrackedJobsPollQuery__
 *
 * To run a query within a React component, call `useTrackedJobsPollQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackedJobsPollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackedJobsPollQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrackedJobsPollQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>(TrackedJobsPollDocument, options);
      }
export function useTrackedJobsPollLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>(TrackedJobsPollDocument, options);
        }
// @ts-ignore
export function useTrackedJobsPollSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>;
export function useTrackedJobsPollSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrackedJobsPollQuery | undefined, TrackedJobsPollQueryVariables>;
export function useTrackedJobsPollSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>(TrackedJobsPollDocument, options);
        }
export type TrackedJobsPollQueryHookResult = ReturnType<typeof useTrackedJobsPollQuery>;
export type TrackedJobsPollLazyQueryHookResult = ReturnType<typeof useTrackedJobsPollLazyQuery>;
export type TrackedJobsPollSuspenseQueryHookResult = ReturnType<typeof useTrackedJobsPollSuspenseQuery>;
export type TrackedJobsPollQueryResult = ApolloReactCommon.QueryResult<TrackedJobsPollQuery, TrackedJobsPollQueryVariables>;